const _customObj = {
  gutterBottom: {
    marginBottom: 8
  }
};

export default _customObj;